function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.4163 6.75004H9.99967V1.33337C9.99967 0.650041 9.43301 0.083374 8.74967 0.083374C8.06634 0.083374 7.49967 0.650041 7.49967 1.33337V6.75004H2.08301C1.39967 6.75004 0.833008 7.31671 0.833008 8.00004C0.833008 8.68337 1.39967 9.25004 2.08301 9.25004H7.49967V14.6667C7.49967 15.35 8.06634 15.9167 8.74967 15.9167C9.43301 15.9167 9.99967 15.35 9.99967 14.6667V9.25004H15.4163C16.0997 9.25004 16.6663 8.68337 16.6663 8.00004C16.6663 7.31671 16.0997 6.75004 15.4163 6.75004Z",
  fill: "white",
  fillOpacity: 0.5
});

var SvgAddIndexChartDark = function SvgAddIndexChartDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddIndexChartDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddIndexChartDark.8f894663.svg";
export { ForwardRef as ReactComponent };